import { createApp } from 'vue'
import { createPinia } from 'pinia'
import '@mdi/font/css/materialdesignicons.css'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import { setHeadersProvider, setOnUnauthorized } from './services/api'
import { loadClients } from './config/clients'
import { useSessionStore } from './stores/session'
import { useAuthStore } from './stores/auth'
import { logout } from './services/auth'
import './styles/main.scss'

const app = createApp(App)
const pinia = createPinia()
app.use(pinia)
app.use(vuetify)
app.use(router)

const session = useSessionStore()
const auth = useAuthStore()

setHeadersProvider(() => {
  const headers: Record<string, string> = {}
  if (session.accId) {
    headers['x-ax-workspace'] = session.accId
  }
  if (session.supplierHeader) {
    headers['x-ax-supplier'] = session.supplierHeader
  }
  return headers
})

setOnUnauthorized(() => {
  const returnTo = session.clientKey ? `/${session.clientKey}` : '/'
  auth.clear()
  session.clear()
  logout(returnTo)
})

// El mapeo de clientes viene de Keycloak y las rutas dependen de el: se carga antes de montar
// (el guard del router resuelve el cliente del path de forma sincrona sobre el mapa cargado).
loadClients()
  .catch((err) => console.error('No se pudo cargar el mapeo de clientes del portal:', err))
  .finally(() => app.mount('#app'))
